import { Component } from "react";
import { LabelContainer } from "../assets/style";

export default function SearchInput(props: { title: any, value: any, setMethod: Function, style?: any }) {
    const { title, value, setMethod, style } = props
    const inputStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "24px",
        // maxWidth: "250px",
        width: "100%",
        ...style,
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "400px",
    };
    return (
        <div style={containerStyle}>
            <LabelContainer>
                {title + ": "}
            </LabelContainer>
            <input
                style={inputStyle}
                value={value}
                onChange={(event) => {
                    setMethod(event.target.value)
                }}
            />

        </div>
    );
}
